import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false;

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

/*** @Description: 自适应*/
import 'amfe-flexible';

import './assets/css/index.css'

//全局请求封装
import request from './api/request.js'
Vue.prototype.$request = request;

//配置全局接口地址
import baseUrl from "./api/config.js"
Vue.prototype.$baseUrl = baseUrl.api;

/** @Description:  animate.css*/
import animated from 'animate.css'
Vue.use(animated)

Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
]

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
